import { ConfigSyncStatusDto } from '../dto/config-sync.dto'
import { ConfigSyncDeviceStatusModel } from '../../models/config-sync.model'

/**
 * Only devices with a usable `deviceId` are kept — the backend schema documents `deviceId` as a
 * numeric `DeviceLink.id`, but the handler actually returns the device serial number as a string
 * (see route docs). Filtering here guards against malformed/empty entries the UI could not display.
 */
export const configSyncStatusDtoToModelTransformer = (dto: ConfigSyncStatusDto): ConfigSyncDeviceStatusModel[] =>
  (dto ?? [])
    .filter(
      (device): device is ConfigSyncStatusDto[number] & { deviceId: string } => typeof device.deviceId === 'string' && device.deviceId.length > 0
    )
    .map(device => ({
      deviceId: device.deviceId,
      deviceType: device.deviceType,
      state: device.state,
      lastUpdate: device.lastUpdate,
    }))

export default configSyncStatusDtoToModelTransformer
